import { NavLink } from 'react-router-dom';
import { CATEGORIES } from '../lib/categories';
import { useAuth } from '../context/AuthContext';

interface NavItem {
  to: string;
  label: string;
}

export function Sidebar({ onNavigate }: { onNavigate?: () => void }) {
  const { isAuthenticated } = useAuth();

  const economic = CATEGORIES.filter((c) => c.group === 'Economic');
  const esg = CATEGORIES.filter((c) => c.group === 'ESG & Sustainability');
  const global = CATEGORIES.filter((c) => c.group === 'Global');

  const renderItems = (items: NavItem[]) =>
    items.map((item) => (
      <NavLink
        key={item.to}
        to={item.to}
        end={item.to === '/'}
        className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
        onClick={onNavigate}
      >
        {item.label}
      </NavLink>
    ));

  const catItems = (group: typeof CATEGORIES) => group.map((c) => ({ to: `/category/${c.id}`, label: c.label }));

  return (
    <nav className="sidebar">
      <div className="sidebar-header">
        <NavLink to="/" className="brand" onClick={onNavigate}>
          <span className="brand-mark">◆</span>
          <span>
            <span className="brand-name">ESGDash</span>
            <span className="brand-sub">Analytics Platform</span>
          </span>
        </NavLink>
      </div>

      <div className="nav-section">
        <div className="nav-section-title">Workspace</div>
        {renderItems([
          { to: '/overview', label: 'Overview' },
          { to: '/explore', label: 'Explore Data' },
          { to: '/watchlist', label: 'Watchlist' },
          { to: '/dashboards', label: 'Dashboards' },
        ])}
      </div>

      <div className="nav-section">
        <div className="nav-section-title">Economic Data</div>
        {renderItems(catItems(economic))}
      </div>

      <div className="nav-section">
        <div className="nav-section-title">ESG & Sustainability</div>
        {renderItems(catItems(esg))}
      </div>

      <div className="nav-section">
        <div className="nav-section-title">Global</div>
        {renderItems([
          { to: '/compare', label: 'Country Comparison' },
          { to: '/heatmap', label: 'ESG Heatmap' },
          ...catItems(global),
        ])}
      </div>

      <div className="nav-section">
        <div className="nav-section-title">Account</div>
        {isAuthenticated
          ? renderItems([{ to: '/account', label: 'Account & API' }])
          : renderItems([{ to: '/login', label: 'Sign in' }])}
      </div>
    </nav>
  );
}
